"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var messages = {
  en: {
    com: {
      components: {
        headerCartButton: {
          cartButton: 'Cart'
        }
      },
      productDetail: {
        parameters: {
          title: 'Parameters'
        }
      },
      productAvailability: {
        format: {
          available: 'In stock',
          moreThanX: 'Over {min} items in stock',
          exactCount: '{value} items in stock',
          notAvailable: 'Not available'
        }
      },
      imageGallery: {
        thumbnailsMore: '+ {number} more'
      },
      relatedProducts: {
        title: 'Related Products'
      },
      productAccessories: {
        title: 'Product Accessories'
      },
      productDetailImageGallery: {
        noImage: 'No Image'
      },
      productAvailabilityFieldPreviewWithPopup: {
        button: 'When can I get item?'
      }
    }
  }
};
var _default = messages;
exports.default = _default;